"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendOverHttp = void 0;
function createCORSRequest(method, url) {
    if (!XMLHttpRequest)
        throw new Error("No XMLHttpRequest provided by browser");
    var xhr = new XMLHttpRequest();
    if ("withCredentials" in xhr) {
        // XHR for Chrome/Firefox/Opera/Safari/IE10+.
        xhr.open(method, url, true);
        return xhr;
    }
    else {
        throw new Error("CORS not supported by browser");
    }
}
// navigator.sendBeacon polyfill
// http://stackoverflow.com/questions/15479103/can-beforeunload-unload-be-used-to-send-xmlhttprequests-reliably
var sendOverHttp = function (url, data) {
    // Under some conditions `sendBeacon` can require being forcibly bound or it fires an IllegalInvocation Exception
    // Even then, it can still throw, we can still fallback onto XMLHttpRequest.
    // A similar change has been made across nextjs/ga/etc. e.g. https://github.com/vercel/next.js/pull/26601/files
    var send = window.navigator.sendBeacon && window.navigator.sendBeacon.bind(window.navigator);
    if (send) {
        try {
            send(url, data);
            return;
        }
        catch (_) { }
    }
    if (XMLHttpRequest) {
        var xhr_1 = createCORSRequest("POST", url);
        // blogs claim the timeout helps to reduce IE aborted request errors
        setTimeout(function () {
            xhr_1.send(data);
        }, 0);
    }
    else {
        throw new Error("No applicable way to send data -- define a `send` method in init");
    }
};
exports.sendOverHttp = sendOverHttp;
//# sourceMappingURL=sender.js.map